import { render } from "./TicketPreviewPage.vue?vue&type=template&id=49b99b72&ts=true"
import script from "./TicketPreviewPage.vue?vue&type=script&lang=ts"
export * from "./TicketPreviewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__